import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { Button } from './styles';

type BackToTopButtonProps = {
    onClick: () => void;
    shouldCenter?: boolean;
};

const BackToTopButton: FC<BackToTopButtonProps> = ({ onClick, shouldCenter }) => {
    return (
        <Button onClick={onClick} $shouldCenter={shouldCenter}>
            <FormattedMessage
                description="Prompt for user to be brought back to the top of the page"
                defaultMessage="Back to top"
            />
        </Button>
    );
};

export default BackToTopButton;
